import { REFERRAL_SENT_STATUS } from '../services/adminReferralService';

/** mm/dd/yyyy: hh:mm (local timezone) */
export function formatReferralSentAt(iso) {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return String(iso);
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    const yyyy = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, '0');
    const min = String(d.getMinutes()).padStart(2, '0');
    return `${mm}/${dd}/${yyyy}: ${hh}:${min}`;
  } catch {
    return String(iso);
  }
}

/** @param {import('../services/adminReferralService').ReferralCompanyGroup | Record<string, unknown>} companyGroup */
export function getReferralSends(companyGroup) {
  if (companyGroup?.sends?.length) {
    return [...companyGroup.sends];
  }
  if (companyGroup?.status === REFERRAL_SENT_STATUS || companyGroup?.sentAt || companyGroup?.panelContactId) {
    return [
      {
        sentAt: companyGroup.sentAt,
        sentToName: companyGroup.sentToName,
        sentToEmail: companyGroup.sentToEmail,
        panelContactId: companyGroup.panelContactId,
      },
    ];
  }
  return [];
}

/** Newest send first. */
export function sortSendsNewestFirst(sends) {
  return [...(sends || [])].sort((a, b) => {
    const ta = a?.sentAt ? new Date(a.sentAt).getTime() : 0;
    const tb = b?.sentAt ? new Date(b.sentAt).getTime() : 0;
    return tb - ta;
  });
}

export function formatSentTo(send) {
  if (!send) return '—';
  const who = send.sentToName || send.sentToEmail;
  if (send.sentToEmail && send.sentToName && send.sentToEmail !== send.sentToName) {
    return `${send.sentToName} (${send.sentToEmail})`;
  }
  return who || '—';
}

/** Candidate history: date only, no panel recipient. */
export function formatReferralSentForCandidate(send) {
  const when = formatReferralSentAt(send?.sentAt);
  return when ? `Referral request sent on ${when}` : 'Referral request sent';
}

/** e.g. Referral request sent to Jane Doe on 05/19/2026: 14:30 */
export function formatReferralSentSentence(send) {
  const who = formatSentTo(send);
  const when = formatReferralSentAt(send?.sentAt);
  if (!who || who === '—') {
    return when ? `Referral request sent on ${when}` : 'Referral request sent';
  }
  if (!when) {
    return `Referral request sent to ${who}`;
  }
  return `Referral request sent to ${who} on ${when}`;
}

export function formatReferralSendLine(send) {
  if (!send) return '';
  const parts = [];
  if (send.sentAt) {
    parts.push(formatReferralSentAt(send.sentAt));
  }
  const who = send.sentToName || send.sentToEmail;
  if (who) {
    parts.push(
      send.sentToEmail && send.sentToName && send.sentToEmail !== send.sentToName
        ? `${send.sentToName} (${send.sentToEmail})`
        : who
    );
  }
  return parts.join(' · ');
}

/** @deprecated use getReferralSends + formatReferralSendLine */
export function formatReferralSentMeta(companyGroup) {
  const sends = getReferralSends(companyGroup);
  if (sends.length === 0) return '';
  return formatReferralSendLine(sends[sends.length - 1]);
}
